import { Http } from '@mygpt/app/http';
import { User } from '@mygpt/app/users/services/get-enterprise-plan-list';

export interface GetUserByEmailParams {
  email: string;
}

/**
 * 根据邮箱查找用户
 * @param params
 * @returns
 */
export const getUserByEmailService = (params: GetUserByEmailParams) => {
  const { get } = Http.use();
  return get<User[]>(`/users/email?email=${params.email}`);
};
